export default __webpack_public_path__ + "static/media/user_edited_white.a3664fb4.svg";